import { Injectable } from '@angular/core';
import { SupabaseBaseHttpService } from '@examdojo/supabase';
import { from } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ClassHttpService extends SupabaseBaseHttpService<'classes', 'classroom'> {
  readonly schema = 'classroom';
  readonly tableName = 'classes';
  private readonly viewName = 'teacher_classes_list';

  fetchAllClassesView() {
    return from(
      this.supabase.client
        .schema(this.schema)
        .from(this.viewName)
        .select('*')
        .throwOnError()
        .then((response) => response.data!),
    );
  }

  fetchClassViewById(id: string) {
    return from(
      this.supabase.client
        .schema(this.schema)
        .from(this.viewName)
        .select('*')
        .eq('id', id)
        .single()
        .throwOnError()
        .then((response) => response.data!),
    );
  }

  archive(classId: string) {
    return from(
      this.supabase.client
        .schema(this.schema)
        .from(this.tableName)
        .update({ archived_at: new Date().toISOString() })
        .eq('id', classId)
        .throwOnError()
        .then(() => undefined),
    );
  }

  setEnrollmentCloseAt(classId: string, closedAt: string | null) {
    return from(
      this.supabase.client
        .schema(this.schema)
        .from(this.tableName)
        .update({ enrollment_closed_at: closedAt })
        .eq('id', classId)
        .throwOnError()
        .then(() => undefined),
    );
  }

  resetEnrollmentCode(classId: string) {
    const newCode = Math.random().toString(36).substring(2, 8).toUpperCase();
    return from(
      this.supabase.client
        .schema(this.schema)
        .from(this.tableName)
        .update({ enrollment_code: newCode })
        .eq('id', classId)
        .throwOnError()
        .then(() => newCode),
    );
  }
}
